import {HttpClient} from './httpClient' 
import {API_URL} from './RestAPI'
import apiHeaders from './apiHeaders'
import { setUrlForGetRequest } from './sharedFunctions'

//Setting the products URI
const PRODUCT_API = `${API_URL}/products`
const PRODUCT_COLLECTION_API = `${API_URL}/product`
const PRODUCT_VARIANT_URL = `${API_URL}/product-variants`

const getProductVariants = (params) => {
  let url = setUrlForGetRequest(PRODUCT_VARIANT_URL, params)
  return HttpClient.get(url, apiHeaders())
}

// Create
const createProduct = product => {
  return HttpClient.post(
    `${PRODUCT_API}/create`,
    product,
    apiHeaders()
  )
}

// Read
const getProducts = (params) => {
  let url = setUrlForGetRequest(PRODUCT_API, params)
  return HttpClient.get(url, apiHeaders())
}

// Read
const searchProducts = (q, page=0, all=false, dependent = {}) => {
  return HttpClient.get(
    `${PRODUCT_API}?q=${q}&page=${page}&all=${all}`,
    apiHeaders(dependent)
  )
}


const productsForOrders = (q, dependent = {}) => {
  return HttpClient.get(
    `${PRODUCT_API}/list-for-orders?q=${q}`,
    apiHeaders(dependent)
  )
}

// Get
const getProduct = id => {
  return HttpClient.get(
    `${PRODUCT_API}/${id}`,
    apiHeaders()
  )
}

// Get
const getProductStats = id => {
  return HttpClient.get(
    `${PRODUCT_API}/${id}/stats`,
    apiHeaders()
  )
}

// Update
const updateProduct = (id, product) => {
  return HttpClient.put(
    `${PRODUCT_API}/${id}/update`,
    product,
    apiHeaders()
  )
}

// Delete
const removeProduct = product => {
  return HttpClient.delete(
    `${PRODUCT_API}/${product.id}`,
    apiHeaders()
  )
}
// Create Product image
const createProductImage = (id, image, dependent = {}) => {
  return HttpClient.post(
    `${PRODUCT_API}/${id}/productimages/create`,
    image,
    apiHeaders(dependent)
  )
}

// Delete Product image
const removeProductImage = (id, imageId) => {
  return HttpClient.delete(
    `${PRODUCT_API}/${id}/productimages/${imageId}`,
    apiHeaders()
  )
}

const updateProductImage = (id, image) => {
  return HttpClient.put(
    `${PRODUCT_API}/${id}/productimages/${image.id}`,
    image,
    apiHeaders()
  )
}

const addToCollection = (body) => {
  return HttpClient.post(
    `${PRODUCT_COLLECTION_API}/addCollections`,
    body,
    apiHeaders()
  )
}

// Update product positions
const updateProductPositions = (positions) => {
  return HttpClient.put(
    `${PRODUCT_API}/positions`,
    { products: positions },
    apiHeaders()
  );
}

const sendWaitlistEmails = (body) => {
  return HttpClient.post(
    `${PRODUCT_VARIANT_URL}/bulk-notify`,
    body,
    apiHeaders()
  );
};

const getWaitlistVariants = () => {
  return HttpClient.get(
    `${PRODUCT_VARIANT_URL}/bulk-variants/`,
    apiHeaders()
  );
};


const fetchBulkStock = () => {
  return HttpClient.get(
    `${PRODUCT_API}/sync/bulk-stock`,
    apiHeaders()
  );
};

const bulkSyncStock = (id) => {
  return HttpClient.post(
    `${PRODUCT_API}/bulk-sync-stock`,
    id,
    apiHeaders()
  );
};

// Clear Fulfillment Message
const clearFulfillmentMessage = (id) => {
  return HttpClient.post(
    `${PRODUCT_API}/${id}/clear-fulfillment-message`,
    {},
    apiHeaders()
  )
}

const duplicateProduct = (id) => {
  return HttpClient.post(
    `${PRODUCT_API}/${id}/duplicate`,
    {},
    apiHeaders()
  )
}

const archiveProduct = (id, dependent = {}) => {
  return HttpClient.post(
    `${PRODUCT_API}/${id}/archive`,
    {},
    apiHeaders(dependent)
  )
}

const unarchiveProduct = (id, dependent = {}) => {
  return HttpClient.post(
    `${PRODUCT_API}/${id}/unarchive`,
    {},
    apiHeaders(dependent)
  )
}

const bulkUpdateLowStock = (payload) => {
  return HttpClient.put(
    `${PRODUCT_API}/bulk-low-stock`,
    payload,
    apiHeaders()
  );
};

const getOnDemandCatalogue = ({ page = 1, count = 20 }) => {
  const url = `${PRODUCT_API}/on-demand/catalogue?page=${page}&count=${count}`;
  return HttpClient.get(url, apiHeaders());
};

const importOnDemandProducts = (payload) => {
  return HttpClient.post(
    `${PRODUCT_API}/on-demand/import`,
    payload,
    apiHeaders()
  );
};

const importVariantsFromCatalogue = (productId, payload) => {
  return HttpClient.post(
    `${API_URL}/products/${productId}/on-demand/variants/import`,
    payload,
    apiHeaders()
  );
};

//Encapsulating in a JSON object
const ProductApi = {getProducts, productsForOrders, searchProducts, createProduct, getProduct, getProductStats, updateProduct, removeProduct, createProductImage, removeProductImage, addToCollection, updateProductImage, getProductVariants, updateProductPositions, sendWaitlistEmails, getWaitlistVariants, fetchBulkStock, bulkSyncStock, clearFulfillmentMessage, duplicateProduct, archiveProduct, unarchiveProduct, bulkUpdateLowStock, getOnDemandCatalogue, importOnDemandProducts, importVariantsFromCatalogue}

export {ProductApi}
